// extracted by mini-css-extract-plugin
var _1 = "message-row__YnPTl";
var _2 = "message-row__avatar-wrapper__dRSQu";
export { _1 as "messageRow", _2 as "messageRowAvatarWrapper" }
